import React from 'react';
import 'assets/css/detalhes-anestesia.css';

export default function ItensPedidoCirurgia(props) {
  return (
    <div className="div-detalhes">
      <p>
        <strong>{`Anestesia Proposta: `}</strong>
        {`${props.detalhes?.tipoanestesia}`}
      </p>
      <p>
        <strong>{`Motivo de Avaliação Pré Anestésica: `}</strong>
        {`${props.detalhes?.motivoAvaliacaoAnestesica}`}
      </p>
    </div>
  );
}
